import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const tableColumns = [
        {
            label: "字典名称",
            prop: "dictValue",
            align: "left",
            show: true
        },
        {
            label: "字典值",
            prop: "dictKey",
            align: "center",
            show: true
        },
        {
            label: "字典类型",
            prop: "type",
            align: "center",
            show: true
        },
        {
            label: "字典描述",
            prop: "description",
            align: "center",
            show: true
        },
    ]

    const formItems = [
        // {
        //     label: "上级字典名称",
        //     span: 24,
        //     placeholder: '请选择上级字典名称',
        //     model: "parentId",
        //     type: 'select',
        //     options: [],
        //     labelWidth: '150px',
        //     disabled: false,
        //     change: that.parentDicChange
        // },
        {
            label: "字典类型",
            span: 24,
            placeholder: '请输入字典类型',
            model: "type",
            labelWidth: '150px',
            disabled: false,
        },
        {
            label: "字典名称",
            span: 24,
            placeholder: '请输入字典名称',
            model: "dictValue",
            labelWidth: '150px',
        },
        {
            label: "字典值",
            span: 24,
            placeholder: '请输入字典值',
            model: "dictKey",
            labelWidth: '150px',
        },
        {
            label: "字典描述",
            span: 24,
            placeholder: '请输入字典描述信息',
            model: "description",
            labelWidth: '150px',
        },
    ]
    const formRules = {
        // parent: [{
        //     required: true,
        //     message: "请选择上级字典名称",
        //     trigger: "blur"
        // }],
        dictValue: [{
            required: true,
            message: "请输入字典名称",
            trigger: "blur"
        }],
        dictKey: [{
            required: true,
            message: "请输入字典值",
            trigger: "blur"
        }],
        type: [{
            required: true,
            message: "请输入字典类型",
            trigger: "blur"
        }],
    }

    const tree = {
        props: {
            parent: "parentId", // 父级唯一标识
            value: "dictKey", // 唯一标识
            label: "dictValue", // 标签显示
            children: "childrenList" // 子级
        }
    }
    return {
        formItems,
        formRules,
        tableColumns,
        tree
    }
}